import { ReactNode } from "react";

import { BaseEntityDataDto, EntityType } from "@/core/api/generated/v1";

import EntityNotFoundAlert from "../../AppAlerts/EntityNotFoundAlert";

export interface BaseEntityDataViewOwnProps<TEntityData extends BaseEntityDataDto> {
  entityType: EntityType;
  entityData: Nil<TEntityData>;
  children: ReactNode;
}

export type BaseEntityDataViewProps<TEntityData extends BaseEntityDataDto> =
  BaseEntityDataViewOwnProps<TEntityData>;

/** Interface to be used by wrapper components that utilize this component. */
export interface BaseEntityDataViewInheritableProps<TEntityData extends BaseEntityDataDto> {
  entityData: Nil<TEntityData>;
}

export function BaseEntityDataView<TEntityData extends BaseEntityDataDto = BaseEntityDataDto>({
  entityType,
  entityData,
  children,
}: BaseEntityDataViewProps<TEntityData>) {
  if (!entityData) {
    return <EntityNotFoundAlert />;
  }

  return children;
}
